//export const API_URL = `http://localhost:5000/api/`
export const API_URL = `https://api.vrsurgut.ru/api/`
//export const IMG_URL = `http://localhost:5000/`
export const IMG_URL = `https://api.vrsurgut.ru/`

export default API_URL;